import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const preferenceApi = createApi({
  reducerPath: 'preferenceApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPreferences: builder.query({
      query: () => ({
        url: `/WebAuth/GetStudentNotificationPreference`,
        method: "Get"
      }),
    }),
    updatePreferences: builder.mutation({
      query: (credentials) => ({
        url: `/WebAuth/UpdatePreferences`,
        method: "POST",
        body: {preferences: credentials.preferences}
      }),
    }),
  }),
});

export const { 
  useGetPreferencesQuery,
  useUpdatePreferencesMutation
} = preferenceApi;